import { Link } from 'gatsby';
import React from 'react';
import { Button, Container } from 'react-bootstrap';
import atlassian from '../assets/images/atlassian.svg';
import github from '../assets/images/github.svg';
import youtrack from '../assets/images/youtrack.svg';
import trello from '../assets/images/Trello.svg';
import zapier from '../assets/images/zapier.svg';
import arrow from '../assets/images/right-arrow-white.svg';
import jiraWhite from '../assets/images/jira-white.svg';
import githubWhite from '../assets/images/github-white.svg';
import { reportConversion } from '../util/gtag';


const Integration = ({ background }: { background?: string }) => {
  return (
    <Container>
      <div className="d-flex flex-column flex-lg-row justify-content-between py-4 py-lg-5">
        <div className="d-flex flex-column align-items-lg-start col-12 col-lg-7 order-2 order-lg-1">
          <div className="fw-600 integration-heading  fnt-sm-16 mb-4 ">
            Seamless integration: bugs.work with the platforms you love!
          </div>
          <div className="fw-400   integration-subheading fnt-sm-14 mb-4">
            bugs.work seamlessly integrates with Slack, Jira, Trello, and GitHub
            to enhance your bug tracking and testing workflow. When you report
            bugs using bugs.work, they are automatically created on your chosen
            platforms, complete with all system metadata and debugging
            information. Sign up now to streamline your processes and improve
            efficiency!
          </div>
          <Link
            to={`${process.env.GATSBY_APP_URL}/registration/`}
            target="_blank"
            className='text-center'
          >
            <Button onClick={reportConversion} size="lg" className="font-14 fw-500 btn-contact-us">
              Start for free <img src={arrow} alt="arrow" className="ms-2" />
            </Button>
          </Link>
        </div>
        <div className="d-flex flex-row align-items-center justify-content-between flex-wrap col-lg-4 order-1 order-lg-2">
          <img src={trello} className="me-3 mb-3 mb-lg-4 integration-image" alt="youtrack" />
          <img src={youtrack} className="me-4 mb-3 mb-lg-4" alt="youtrack" />
          {background === 'dark' ? (
            <img src={jiraWhite} className="me-4 mb-3 mb-lg-4 integration-image" alt="github" />
          ) : (
            <img src={atlassian} className="me-4 mb-3 mb-lg-4 integration-image" alt="atlassian" />
          )}
          {background === 'dark' ? (
            <img src={githubWhite} className="me-4 mb-3 mb-lg-4 integration-image" alt="github" />
          ) : (
            <img src={github} className="me-4 mb-3 mb-lg-4 integration-image" alt="github" />
          )}
          
          <img src={zapier} height={50} width={50} className="me-3 mb-3 mb-lg-4 integration-image" alt="youtrack" />
          <div className="fw-600 fnt-sm-16 fnt-20 w-100 d-flex justify-content-center  mb-4 mb-lg-0">
            and many more...
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Integration;
